import MainMarcoRegulatorio from "../components/marco-regulatorio/MainMarcoRegulatorio";

function MarcoRegulatorio() {
    return ( <MainMarcoRegulatorio/> );
}

export default MarcoRegulatorio;